export default __webpack_public_path__ + "static/flag-round-ara-b8e8a57c3c085347952490c230ef543e.svg";